import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import {
    slideDown,
    slideUp,
} from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', () => {
    const fbiwcSections = document.querySelectorAll('.full-bleed-image-with-cards-section');

    fbiwcSections.forEach(section => {
        const sliderEl = section.querySelector('.fbic-slider');
        const imgSliderEl = section.querySelector('.fbic-img-slider');
        const sliderContent = section.querySelectorAll('.fbic-item');

        let swiperInstance = null;
        let imgSwiperInstance = null;

        imgSwiperInstance = new Swiper(imgSliderEl, {
            spaceBetween: 0,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            speed: 600,
        });

        function initSwiper() {
            swiperInstance = new Swiper(sliderEl, {
                spaceBetween: 24,
                slidesPerView: 1,
                autoHeight: true,
                navigation: {
                    prevEl: section.querySelector('.fbic-button-prev'),
                    nextEl: section.querySelector('.fbic-button-next'),
                },
                pagination: {
                    el: section.querySelector('.fbic-pagination'),
                    clickable: true,
                },
                on: {
                    slideChange: function() {
                        const index = this.activeIndex;

                        if (imgSwiperInstance && imgSwiperInstance.activeIndex !== index) {
                            imgSwiperInstance.slideTo(index);
                        }

                        // optional: update active class in desktop-like structure
                        sliderContent.forEach((item, i) => {
                            item.classList.toggle('is-active', i === index);
                        });
                    },
                },
            });
        }

        function destroySwiper() {
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        }

        function handleSwiper() {
            const isDesktop = window.innerWidth >= 992;

            if (isDesktop) {
                destroySwiper();

                sliderContent.forEach((item, index) => {
                    const card = item.querySelector('.fbic-card');
                    const content = item.querySelector('.card-content');

                    card.addEventListener('click', () => {
                        const isActive = item.classList.contains('is-active');

                        // CLOSE ALL OTHERS
                        sliderContent.forEach((otherItem) => {
                            if (otherItem !== item && otherItem.classList.contains('is-active')) {
                                otherItem.classList.remove('is-active');

                                const otherContent = otherItem.querySelector('.card-content');
                                if (otherContent) {
                                    slideUp(otherContent);

                                    if (otherContent.children.length) {
                                        Array.from(otherContent.children).forEach(child => {
                                            child.style.opacity = 0;
                                        });
                                    }
                                }
                            }
                        });

                        if (isActive) {
                            return;
                        }
                        item.classList.add('is-active');

                        if (content) {
                            slideDown(content);

                            if (content.children.length) {
                                Array.from(content.children).forEach(child => {
                                    setTimeout(() => {
                                        child.style.opacity = 1;
                                    }, 300);
                                });
                            }
                        }

                        // ✅ NEW: sync image swiper
                        if (imgSwiperInstance && !isNaN(index)) {
                            imgSwiperInstance.slideTo(index);
                        }
                    });
                });
            } else {
                if (!swiperInstance) {
                    initSwiper();
                }
            }
        }

        handleSwiper();
        window.addEventListener('resize', handleSwiper);
    });
});